import { z } from 'zod';

export const CartGlobalViewModel = z.object({
    cartGuid: z.string(),
    cartId: z.string(),
    framenumber: z.string(),
    storeGuid: z.string(),
    storeName: z.string(),
    externalStoreId: z.string().nullish(),
    createdOnInventories: z.string(),
    modifiedOnInventories: z.string(),
    createdOnCarts: z.string().nullish(),
    modifiedOnCarts: z.string().nullish(),
    changedByCarts: z.string().nullish(),
    productNumber: z.string().nullish(),
    currentEnvironment: z.string().nullish(),
    isDisabled: z.boolean().nullish(),
    isGpsDisabled: z.boolean().nullish(),
    hostname: z.string().nullish(),
    deploymentStatus: z.string().nullish(),
    lastSeen: z.string().nullish(),
    scaleCalibration: z.string().nullish(),
});
export type CartGlobalViewModel = z.infer<typeof CartGlobalViewModel>;

export const CartLocationModel = z.object({
    cartGuid: z.string().nullish(),
    cartId: z.string().nullish(),
    storeGuid: z.string().nullish(),
    locations: z.array(
        z
            .object({
                lat: z.number().nullish(),
                lon: z.number().nullish(),
                createdOn: z.date().nullish(),
            })
            .nullish(),
    ),
});

export type CartLocationModel = z.infer<typeof CartLocationModel>;
